import script from "./DisbursementSummaryItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisbursementSummaryItem.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/certification-updates/disbursements.css?vue&type=style&index=0&id=5facc88b&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5facc88b"]])

export default __exports__